import React, { useRef, useEffect, useId } from "react";

const RadioButton = ({
  label,
  name,
  value,
  checked,
  onChange,
  onClick,
  disabled = false,
  style = {},
  ...props
}) => {
  // Ensure input is always clickable even if parent has pointer-events: none
  const inputStyle = { pointerEvents: "auto", cursor: "pointer", ...style };
  const inputRef = useRef(null);
  const inputId = useId();

  // Sync the DOM with the checked prop to ensure visual state matches
  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.checked = checked;
    }
  }, [checked]);

  const handleClick = (e) => {
    // If onClick is provided, call it first
    if (onClick) {
      onClick(e);
    }
  };

  return (
    <label
      htmlFor={inputId}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
        cursor: disabled ? "not-allowed" : "pointer",
        userSelect: "none",
      }}
    >
      <input
        ref={inputRef}
        id={inputId}
        type="radio"
        name={name}
        value={value}
        checked={checked}
        onChange={onChange}
        onClick={handleClick}
        disabled={disabled}
        style={inputStyle}
        {...props}
      />
      {React.isValidElement(label) && typeof label === "object" ? (
        React.cloneElement(label, {
          style: { marginLeft: 0, ...(label.props?.style || {}) },
        })
      ) : (
        <span>{label}</span>
      )}
    </label>
  );
};

export default RadioButton;
